export const jsQuizz = {
  questions: [
    {
      question: "My boss ___________ in Canada.",
      choices: ["was born", "is born", "born"],
      type: "V1",
      correctAnswer: "was born",
    },
    {
      question:
        "Excuse me, Barbara. I’d like you to meet a friend from New York. _______ Ken Augustine.",
      choices: ["That is", "It is", "This is"],
      type: "V1",
      correctAnswer: "This is",
    },
    {
      question: "Please _________ a seat. I’ll be with you in a moment.",
      choices: ["have", "go on", "take"],
      type: "V1",
      correctAnswer: "have",
    },
    {
      question: "People here usually ______ at about 10 o’clock.",
      choices: ["take up", "wake up", "has"],
      type: "V1",
      correctAnswer: "wake up",
    },
    {
      question: "Most women are________ than their husbands.",
      choices: ["young", "more young", "younger"],
      type: "V1",
      correctAnswer: "younger",
    },
    {
      question: "Would you like a cup of coffee?",
      choices: ["No, I don’t.", "No, thanks.", "No, I don’ like."],
      type: "V1",
      correctAnswer: "No, thanks.",
    },
    {
      question: "Where _________ grow up?",
      choices: ["do you", "are you", "did you"],
      type: "V1",
      correctAnswer: "did you",
    },
    {
      question: "I got ______ at midnight.",
      choices: ["home", "in home", "at home"],
      type: "V1",
      correctAnswer: "home",
    },
    {
      question: "I’m very _________ with my new computer.",
      choices: ["lucky", "glad", "happy"],
      type: "V1",
      correctAnswer: "happy",
    },
    {
      question: "She didn’t give me _________ information about the meeting.",
      choices: ["much", "less", "many"],
      type: "V1",
      correctAnswer: "much",
    },
    {
      question: "She lives ______ London.",
      choices: ["at", "in", "on"],
      type: "V1",
      correctAnswer: "in",
    },
    {
      question:
        "I had a headache so I took an aspirin. I feel much _________ now.",
      choices: ["good", "well", "better"],
      type: "V1",
      correctAnswer: "better",
    },
    {
      question: "I’m afraid February 10th isn’t very _______ for me.",
      choices: ["buy", "well", "convenient"],
      type: "V1",
      correctAnswer: "convenient",
    },
    {
      question:
        "___________ you like to pay for the ticket by cheque or credit card?",
      choices: ["Would", "Do", "Are"],
      type: "V1",
      correctAnswer: "Would",
    },
    {
      question: "Mexico City is ________ than Amsterdam.",
      choices: ["biggest", "more big", "bigger"],
      type: "V1",
      correctAnswer: "biggest",
    },
    {
      question: "I usually _________ a shower in the morning.",
      choices: ["take", "have", "go on"],
      type: "V1",
      correctAnswer: "have",
    },
    {
      question: "I don’t want to fly to Paris. Let’s __________ the train.",
      choices: ["take", "have", "go on"],
      type: "V1",
      correctAnswer: "take",
    },
    {
      question: "Don’t work so fast. _________ your time!",
      choices: ["Have", "Go on", "Take"],
      type: "V1",
      correctAnswer: "Take",
    },
    {
      question: "I think I ________ what the problem is.",
      choices: ["hear", "see", "look"],
      type: "V1",
      correctAnswer: "see",
    },
    {
      question: "This morning I __________ a taxi to work.",
      choices: ["had", "went on", "took"],
      type: "V1",
      correctAnswer: "took",
    },
    {
      question: "Do you like juice?",
      choices: [
        "Yes, I do.",
        "Yes, I like it.",
        "Yes, I would. Thank you very much.",
      ],
      type: "V1",
      correctAnswer: "Yes, I do.",
    },
    {
      question: "The company plans to sell its products in Asia _______ .",
      choices: ["in 1987", "next year", "last year"],
      type: "V1",
      correctAnswer: "next year",
    },
    {
      question: "Look! The bus __________.",
      choices: ["came", "is coming", "comes"],
      type: "V1",
      correctAnswer: "is coming",
    },
    {
      question: "Can I _______ you a few questions?",
      choices: ["ask", "make", "do"],
      type: "V1",
      correctAnswer: "ask",
    },
    {
      question: "Last year I _________ a long journey to China.",
      choices: ["made", "went on", "took"],
      type: "V1",
      correctAnswer: "took",
    },
    {
      question: "How do you do?",
      choices: ["Yes, I do.", "I work in a bank.", "Good, how do you do?"],
      type: "V1",
      correctAnswer: "Good, how do you do?",
    },
    {
      question: "You work too much. Why don’t you _________ a holiday?",
      choices: ["take", "have", "make"],
      type: "V1",
      correctAnswer: "take",
    },
    {
      question: "Tessa _______ British.",
      choices: ["am", "is", "are"],
      type: "V1",
      correctAnswer: "is",
    },
    {
      question: "It was a very good party. Everyone ________ a wonderful time.",
      choices: ["had", "made", "took"],
      type: "V1",
      correctAnswer: "had",
    },
    {
      question:
        "She lived in New York between 1983 and 1990, so she worked there ________.",
      choices: ["it make seven years", "seven years ago", "for seven years"],
      type: "V1",
      correctAnswer: "for seven years",
    },
  ],
};

export const resultInitalState = {
  score: 0,
  correctAnswers: 0,
};
